import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  constructor(
    private http: HttpClient,
    private globalService: GlobalService
  ) { }

  newProcces(token, procces): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.getNewProccesURL, procces, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  getProcces(token): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getGetProccesURL, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  executeProccesCus(token, obj, id): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.getRunProccesCusURL(id), obj, httpOptions)
  }

  executeProccesGroup(token, obj, id): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.getRunProccesGroupURL(id), obj, httpOptions)
  }

  getProccesInstances(token, id): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getProccesInstanceURL(id), httpOptions)

  }

  getTypeDeadline(token, id): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getTypeDeadline(id), httpOptions)
  }

  inputInstance(token: string, obj: any): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };

    return this.http.post<any>(this.globalService.getInputInstance, obj, httpOptions);
  }

  storeActivity(token: string, id: number): Observable<any>{
    let httpOptions  = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    
    return this.http.get<any>(this.globalService.storActivityURL(id), httpOptions);
  }

}
